import type { KeyboardEvent } from 'react'

/**
 * Creates a keyboard event handler for checkboxes that toggles the checkbox
 * when Enter or Space keys are pressed, following accessibility best practices.
 *
 * @param onChange - Function to call when the checkbox should be toggled
 * @param currentValue - Current value of the checkbox
 * @returns Keyboard event handler function
 */
export const createCheckboxKeyHandler = (onChange: (value: boolean) => void, currentValue: boolean) => {
  return (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onChange(!currentValue)
    }
  }
}
